import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { AnalysisType } from 'features/analysis/types'
import { FormattedMessage } from 'react-intl'
import BaseSource from '../Commons/Form/BaseSource'

function AnalysisBase({ analysisType }: { analysisType: AnalysisType }) {
  return (
    <>
      <Box mb={1.5}>
        <Typography variant="subtitle2">
          <FormattedMessage id={`analysis.${analysisType}.data`} />
        </Typography>
      </Box>
      <BaseSource />
    </>
  )
}

export default AnalysisBase
